import { GridComponent } from '@syncfusion/ej2-react-grids';
import styled from 'styled-components';

/** Basically wraps the GridComponent in "styled". (pass className prop if nesting in other Styled components and you need to pass along additional styles for this grid)
    GridComponent (SyncFusion) is rendered as a div with a class of ".e-grid" on it - everything else is a child of that
    Tweaks applied: 
        - font family per UX
        - icon \e796 used for filtered column icon so it is visually better distinguished. code is defined here https://ej2.syncfusion.com/documentation/appearance/icons#available-icons
        - word-break: break-all: fixes word wrap with super long words like TaxReporting.TaxEntries.Permanent.Statutory
        - toolbar background color, border color, icon color, selected row color, row hover color
        - small curve (border radius) to the top of the grid / toolbar
*/
export const StyledSyncFusionGrid = styled(GridComponent)`
    &.e-grid {
        font-family: 'Segoe UI', 'Helvetica Neue', 'Helvetica', 'Arial', san-serif;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    &.e-grid .e-icons.e-filtered:before {
        content: '\\e796';
    }
    &.e-grid .e-excelfilter .e-checkboxfiltertext {
        word-break: break-all;
    }
    &.e-grid .e-toolbar {
        background-color: ${(props) => props.theme.brandPalette.coolLightGrey};
        box-shadow: unset;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        border-bottom: 1px solid ${(props) => props.theme.brandPalette.coolLightGrey};
    }
    &.e-grid .e-toolbar-items {
        background-color: ${(props) => props.theme.brandPalette.coolLightGrey};
    }
    &.e-grid .e-toolbar .e-toolbar-item .e-tbar-btn .e-icons {
        color: ${(props) => props.theme.brandPalette.hyperlinkBlue};
    }
    &.e-grid .e-row:hover .e-rowcell {
        background-color: ${(props) => props.theme.brandPalette.gridHighlightBlue} !important;
    }
    &.e-grid .e-rowcell.e-selectionbackground {
        background-color: ${(props) => props.theme.brandPalette.coolLightGrey};
    }
`;
